export const NAV_LINKS = [
  { path: "/", key: "/", name: "Home" },
  { path: "/about", key: "about", name: "About Us" },
  { path: "/business", key: "business", name: "Business" },
  { path: "/contact", key: "contact", name: "Contact Us" },
];

export const isNavActive = (pathName, key) => {
  if (key === "/") return pathName === "/";
  return pathName !== "/" && pathName.indexOf(key) !== -1;
};
